/* eslint-disable */
import React, { useEffect, useState } from 'react'
import { useDebounce } from 'use-debounce'
import { useHistory } from 'react-router-dom'
import {
    Button,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Select,
    Typography,
    Snackbar,
} from '@material-ui/core'
import moment from 'moment'
import { Alert } from '@material-ui/lab'
import { makeStyles } from '@material-ui/core/styles'
import { axiosAuth as axios } from '../../../../util/axios-instance'
import SimpleModal from '../../../../components/Modal/Modal'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import PageTitle from '../../../../components/FormsUI/PageTitle/PageTitle'
import { useSnackbar } from '../../../../util/snackbar-hook'
import AddInventoryContract from './AddInventoryContract'
import AdminTable from '../../../../components/tables/AdminTable'
import latToCyr from '../../../../util/latToCyr'
import AddButton from '../../../../components/FormsUI/Button/AddButton'
import DeleteContract from '../../../Contracts/DeleteContract'

const useStyles = makeStyles((theme) => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: 400,
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
    pageContainer: {
        padding: 50,
    },
    selectBody: {
        marginLeft: 12,
    },
}))

const InventoryContracts = () => {
    const classes = useStyles()
    const [contracts, setContracts] = useState([])
    const [selectedContract, setSelectedContract] = useState('')
    const [page, setPage] = useState(0)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [totalResults, setTotalResults] = useState(0)
    const [load, setLoad] = useState(false)
    const [locations, setLocations] = useState([])
    const [search, setSearch] = useState({ eng: '', key: '', srb: '' })
    const [searchDebounced] = useDebounce(search, 2000)
    const [addOpen, setAddOpen] = useState(false)
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [deleteId, setDeleteId] = useState('')
    const history = useHistory()
    const [refresh, setRefresh] = useState(false)
    const { snackbar, severity, setSeverity, setSnackbar, handleSnackBarOpen } =
        useSnackbar()

    const getContracts = async () => {
        try {
            setLoad(true)
            const url =
                searchDebounced.eng === ''
                    ? `/api/contract?page=${page + 1}&limit=${rowsPerPage}`
                    : `/api/search/contract?eng=${searchDebounced.eng}&srb=${
                          searchDebounced.srb
                      }&page=${page + 1}&limit=${rowsPerPage}`

            const { data } = await axios.get(url)

            const tableData = data.contracts.reduce((acc, currentEl) => {
                const addElement = {
                    naziv: currentEl.naziv || '',
                    broj: currentEl.broj || '',
                    status: currentEl.status ? latToCyr(currentEl.status) : '',
                    statusLat: currentEl.status ? currentEl.status : '',
                    datumPocetka: currentEl.datumPocetka
                        ? moment(currentEl.datumPocetka).format('DD/MM/YYYY')
                        : '',
                    id: currentEl._id || '',
                    datumZavrsetka: currentEl.datumZavrsetka
                        ? currentEl.datumZavrsetka
                        : null,
                }
                acc.push(addElement)
                return acc
            }, [])

            setContracts(tableData)
            setTotalResults(data.totalResults)
            setLoad(false)
        } catch (error) {
            console.log(error)
            setLoad(true)
            setTimeout(() => {
                setLoad(false)
            }, 400)
        }
    }

    const getSelectedContract = async (id) => {
        try {
            setLoad(true)
            const response = await axios.get(`/api/contract/${id}`)
            setLocations(response.data.contract.lokacije)
            setLoad(false)
        } catch (error) {
            console.log(error)
        }
    }

    useEffect(() => {
        getContracts()
    }, [page, rowsPerPage, refresh, searchDebounced.eng])

    const onRowClick = (rowData) => {
        if (
            rowData.originalEvent.target.nodeName === 'TD' ||
            rowData.originalEvent.target.nodeName === 'DIV'
        ) {
            history.push(`/app/inventar/ugovor/lokacije/${rowData.data.id}`)
        }
        if (
            rowData.originalEvent.target.nodeName === 'SPAN' &&
            rowData.originalEvent.target.parentNode.name === 'obrisi'
        ) {
            setDeleteOpen(true)
            setDeleteId(rowData.data.id)
        }
    }

    const actionBodyTemplate = () => (
        <Grid key="edit" container spacing={2}>
            <Grid item xs={12} className={classes.buttonWrapper}>
                <Button
                    name="obrisi"
                    color="secondary"
                    variant="contained"
                    fullWidth
                    className={classes.deleteButton}
                >
                    {' '}
                    Обриши
                </Button>
            </Grid>
        </Grid>
    )

    const setRefreshState = (state) => {
        setRefresh(state)
    }

    const setSeverityHandler = (state) => {
        setSeverity(state)
    }

    const setSnackbarHandler = (state) => {
        setSnackbar(state)
    }

    return (
        <Grid container className={classes.pageContainer}>
            {load && <SimpleModal />}
            <Snackbar
                open={snackbar.open}
                onClose={handleSnackBarOpen}
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                autoHideDuration={2000}
                key="key"
            >
                <Alert onClose={handleSnackBarOpen} severity={severity}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
            {addOpen ? (
                <AddInventoryContract
                    modalOpen={addOpen}
                    setModal={setAddOpen}
                    setRefreshState={setRefreshState}
                    setSeverityHandler={setSeverityHandler}
                    setSnackbarHandler={setSnackbarHandler}
                />
            ) : null}
            {deleteOpen && deleteId.length > 0 && (
                <DeleteContract
                    id={deleteId}
                    modalOpen={deleteOpen}
                    setModal={(state) => setDeleteOpen(state)}
                    setRefreshState={setRefreshState}
                    setSeverityHandler={setSeverityHandler}
                    setSnackbarHandler={setSnackbarHandler}
                />
            )}
            <Grid container alignItems="center" className={classes.selectBody}>
                <Grid item style={{ marginBottom: 10 }}>
                    <AddButton
                        label="НАПРАВИ НОВИ УГОВОР"
                        click={() => {
                            setAddOpen(true)
                        }}
                    />
                </Grid>
                <Grid item>
                    <AdminTable
                        model="contract"
                        data={contracts}
                        load={load}
                        title="Уговори"
                        totalResults={totalResults}
                        page={page}
                        setPage={setPage}
                        rowsPerPage={rowsPerPage}
                        setRowsPerPage={setRowsPerPage}
                        name="inventoryContractTable"
                        onRowClick={onRowClick}
                        tableHeaders={[
                            { field: 'naziv', header: 'Назив' },
                            { field: 'broj', header: 'Број' },
                            { field: 'status', header: 'Статус' },
                            { field: 'datumPocetka', header: 'Датум почетка' },
                            { field: 'edit', header: '' },
                        ]}
                        actionBodyTemplate={actionBodyTemplate}
                        editColumnwidth={100}
                        setSearch={setSearch}
                        search={search}
                        sortField=""
                        exportFileName="Уговори"
                        withExport={false}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

export default InventoryContracts
